import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntriesService } from '../entries.service';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntryQuestionEditResolver {
  public hasPermissions: boolean = false;

  constructor(private entriesService: EntriesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return forkJoin({
      templateQuestionTypeList: this.entriesService.getAllQuestionTypes(),
      templateQuestionAndEntry: this.entriesService.getQuestionTypeEntryByTemplateQuestionId(route.params['questionId']),
    });
  }
}
